module.exports = __webpack_public_path__ + "static/report-1-11846ebaa53d236c489766767c904c3b.png";